import { createFileRoute } from '@tanstack/react-router'
import { LemlistPlayground } from '@/features/admin/lemlist-playground'

export const Route = createFileRoute('/_authenticated/admin/lemlist-playground')(
  {
    component: LemlistPlayground,
  }
)
